/**
 * Common enum dropdown component connected to create form provider
 */
import { useRfiFormField } from '../../../RfiCreateForm/RfiFormProvider';
import { EnumMultiDropdown, EnumMultiDropdownProps } from './EnumMultiDropdown';

export const EnumMultiDropdownCreateForm = (props: EnumMultiDropdownProps) => {
  const { fieldName } = props;
  const { isFieldsMandatory, isSubmitting, fieldRef } = useRfiFormField(fieldName);

  return (
    <EnumMultiDropdown
      {...props}
      ref={fieldRef}
      disabled={isSubmitting}
      required={isFieldsMandatory}
    />
  );
};
